<template lang="pug">
  v-dialog(v-model="dialog" max-width="400" persistent)
    v-card
      v-card-title(style="font-size: 1.5rem;")
        span Record Payment
        v-spacer
        v-btn.align-right(icon depressed @click="dialog=false")
          v-icon mdi-close
      v-card-text
        v-form(ref="form")
          v-row
            v-col(cols="12")
              v-select(v-model="form.purpose" label="Purpose" :items="purposes" :rules="rules.purpose")
          v-row
            v-col(cols="6")
             v-select(v-model="form.currency" label="Currency" :items="currencies" :rules="rules.currency")
            v-col(cols="6")
              v-text-field(v-model="form.amount" label="Amount" type="number" :rules="rules.amount")
          v-row
            v-col(cols="12")
              span(style="font-size: 16px;") Payment Type
              v-radio-group(v-model="form.payment_type" :rules="rules.payment_type" row)
                v-radio(label="Cash" value="cash")
                v-radio(label="Credit Card" value="card")
          v-row
            v-col(cols="12")
              v-file-input(v-model="form.receipt_file" label="Receipt File" clearable)
          v-row
            v-col(cols="12")
              v-btn.primary(block depressed @click="submit" :loading="loading") Submit
</template>

<script>
export default {
  name: 'ReceiptUploadDialog',
  props: ['value', 'trip'],
  data: (vm) => ({
    form: {
      trip_id: vm.trip.tripid,
      currency: '',
      purpose: '',
      amount: '',
      payment_type: '',
      receipt_file: null
    },
    rules: {
      purpose: [
         v => !!v || 'Select payment purpose'
      ],
      currency: [
         v => !!v || 'Select payment currency'
      ],
      amount: [
         v => !!v || 'Enter payment amount'
      ],
      payment_type: [
         v => !!v || 'Select payment type'
      ]
    },
    dialog: false,
    purposes: [],
    currencies: [],
    loading: false
  }),
  watch: {
    value (val) {
      if (this.dialog !== val) {
        this.dialog = val
      }
      if (val && this.$refs.form) {
        this.$refs.form.reset()
        this.$refs.form.resetValidation()
      }
    },
    dialog (val) {
      this.$emit('input', this.dialog)
    }
  },
  mounted () {
    this.fetchPurposes()
    this.fetchCurrencies()
  },
  methods: {
    fetchPurposes () {
      this.$axios.get('/payment_purposes/')
        .then(resp => {
          this.purposes = [...resp.data]
        })
    },
    fetchCurrencies() {
      const destinationCode = this.trip.tripid.split('/')[0]
      this.$axios.get(`https://trip-manager-api.arbatravel.com/currency/?code=${destinationCode}`)
        .then(resp => {
          this.currencies = [...resp.data.results]
        })
    },
    submit () {
      if (this.$refs.form.validate()) {
        const data = new FormData()
        Object.keys(this.form).forEach(k => {
          const val = this.form[k]
          if (val) {
            data.append(k, val)
          }
        })
        this.loading = true
        this.$axios.post('/upload_receipt/', data)
          .then(resp => {
            this.$store.dispatch('showSnackbar', { message: 'Payment successfully recorded', color: 'success' })
            this.dialog = false
          })
          .catch(e => {
            console.log(e)
            this.$store.dispatch('showSnackbar', { message: 'Payment record failed. Please report to ARBA Travel representative.', color: 'error' })
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>